import React from "react";
import Sylwave from "./pages/apps/sylwave/Sylwave";

// --------------------------------------------------------------------------
// IMPORTANT: Only the Sylwave page is live right now.
//
// Every other page/app in this project (AutoApply / LinkedIn Buddy, Auth,
// Pricing, Help, About, Refund Policy, T&C, BuyUsCoffee, 404, etc.) is
// intentionally disabled below - not just for sylwave.com, but for ANY
// hostname or URL the app is loaded from (including subdomains such as
// test.sylwave.com, ts.sylwave.com, or any other domain pointed at this
// build). AppWithThemeProvider always renders <Sylwave /> and nothing else
// ever mounts, so there is no hostname check left to fall through.
//
// To bring the rest of the app back online in the future, restore the
// commented-out block below (and the "AppWithThemeProvider" export at the
// bottom) and reintroduce whatever hostname/routing logic you need at that
// time.
// --------------------------------------------------------------------------

// import { useContext } from "react";
// import { Route, Routes, Navigate, useLocation } from "react-router-dom";
// import { AuthContext } from "./api/AuthProvider";
// import PrivateRoute from "./PrivateRoute";
// import AutoApplyAuthPage from "./pages/apps/autoApply/AutoApplyAuthPage";
// import Layout from "./common/Layout";
// import AutoApplyMainPage from "./pages/apps/autoApply/AutoApplyMainPage";
// import HelpPage from "./pages/HelpPage";
// import AboutPage from "./pages/AboutPage";
// import AutoApplyHomePage from "./pages/apps/autoApply/AutoApplyHomePage";
// import { ThemeProvider, CssBaseline, GlobalStyles } from "@mui/material";
// import BuyUsCoffee from "./pages/BuyUsCoffee";
// import ForgotPassword from "./pages/Authentication/ForgotPassword";
// import { ColorModeProvider, useTheme, getGlobalStyles } from "./theme";
// import RefundPolicy from "./pages/RefundPolicy";
// import TandC from "./pages/TandC";
// import NotFoundPage from "./pages/NotFoundPage";
// import ScrollToTop from "./common/scrollToTop";
//
// const App: React.FC = () => {
//   const theme = useTheme();
//   const { isLoggedIn } = useContext(AuthContext);
//   const location = useLocation();
//
//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <GlobalStyles styles={getGlobalStyles(theme)} />
//       <ScrollToTop />
//       <Layout>
//         <Routes>
//           <Route path="/" Component={AutoApplyHomePage} />
//           <Route path="/home" Component={AutoApplyHomePage} />
//           <Route path="/about" Component={AboutPage} />
//           <Route path="/help" Component={HelpPage} />
//           <Route path="/buyUsCoffee" Component={BuyUsCoffee} />
//           <Route
//             path="/auth"
//             element={
//               isLoggedIn ? (
//                 <Navigate to="/auth/aamain" replace />
//               ) : (
//                 <AutoApplyAuthPage />
//               )
//             }
//           />
//           <Route path="/auth/login" Component={AutoApplyAuthPage} />
//           <Route path="/auth/forgot-password" element={<ForgotPassword />} />
//           <Route path="/refund-policy" element={<RefundPolicy />} />
//           <Route path="/terms-and-conditions" element={<TandC />} />
//           <Route
//             path="/auth/aamain"
//             element={<Navigate to="/auth/aamain/trigger" replace />}
//           />
//           <Route
//             path="/auth/aamain/*"
//             element={<PrivateRoute element={AutoApplyMainPage} />}
//           />
//           <Route
//             path="/auth/aamain/trigger"
//             element={<PrivateRoute element={AutoApplyMainPage} />}
//           />
//           <Route
//             path="/auth/aamain/jobs"
//             element={<PrivateRoute element={AutoApplyMainPage} />}
//           />
//           <Route
//             path="/auth/aamain/settings"
//             element={<PrivateRoute element={AutoApplyMainPage} />}
//           />
//           <Route
//             path="/auth/aamain/pricing"
//             element={
//               <PrivateRoute element={AutoApplyMainPage} key={location.key} />
//             }
//           />
//           <Route
//             path="/buyUsCoffee/thankyou"
//             element={<PrivateRoute element={BuyUsCoffee} />}
//           />
//           <Route
//             path="/forgot-password"
//             element={<Navigate to="/auth/forgot-password" />}
//           />
//           {/* Catch-all route for 404 Not Found page */}
//           <Route path="*" element={<NotFoundPage />} />
//         </Routes>
//       </Layout>
//     </ThemeProvider>
//   );
// };
//
// const LegacyAppWithThemeProvider: React.FC = () => {
//   const hostname = window.location.hostname.trim().toLowerCase();
//   const isSylwaveDomain =
//     hostname === "sylwave.com" || hostname === "www.sylwave.com";
//
//   if (isSylwaveDomain) {
//     return <Sylwave />;
//   }
//
//   return (
//     <ColorModeProvider>
//       <App />
//     </ColorModeProvider>
//   );
// };

const AppWithThemeProvider: React.FC = () => {
  // Always render Sylwave. No hostname branching, no other routes mounted,
  // no matter what URL/domain/subdomain this build is served from.
  return <Sylwave />;
};

export default AppWithThemeProvider;
